// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import { AppIcon } from '@loa/ui-components';
import type { ClientStatus } from '../types/client';

type ClientStatusBadgeProps = Readonly<{
  status: ClientStatus;
}>;

const statusConfig: Record<ClientStatus, { label: string; bg: string; text: string; iconName: string }> = {
  active: {
    label: 'Active',
    bg: 'bg-success-bg',
    text: 'text-success-text',
    iconName: 'checkbox',
  },
  invited: {
    label: 'Invite sent',
    bg: 'bg-warning-bg',
    text: 'text-warning-text',
    iconName: 'envelope',
  },
  prospect: {
    label: 'Not invited',
    bg: 'bg-error-bg',
    text: 'text-error-text',
    iconName: 'invite not sent',
  },
  inactive: {
    label: 'Archived',
    bg: 'bg-grey-06',
    text: 'text-black',
    iconName: 'archive box',
  },
};

export function ClientStatusBadge({ status }: ClientStatusBadgeProps) {
  const config = statusConfig[status];
  if (!config) return null;

  return (
    <span data-testid="client-status-badge" className={`flex items-center gap-xs px-sm py-xs rounded-[4px] ${config.bg}`}>
      <AppIcon name={config.iconName} size={16} />
      <span className={`overflow-hidden text-ellipsis ${config.text} font-sans text-body-03 font-medium leading-normal`}>
        {config.label}
      </span>
    </span>
  );
}
